import React from "react";

export function Search(): React.JSX.Element {
  return (
    <svg
      fill="none"
      height="40"
      viewBox="0 0 41 40"
      width="41"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.2589 18.9033H26.683"
        stroke="#FF7700"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25781"
      />
      <path
        d="M19.8335 25.7524V12.0543"
        stroke="#FF7700"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25781"
      />
      <path
        d="M19.7028 34.2795C28.2673 34.2795 35.2101 27.3366 35.2101 18.7721C35.2101 10.2076 28.2673 3.26477 19.7028 3.26477C11.1383 3.26477 4.19543 10.2076 4.19543 18.7721C4.19543 27.3366 11.1383 34.2795 19.7028 34.2795Z"
        stroke="#7E7E7E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25781"
      />
      <path
        d="M36.8425 35.9119L33.5778 32.6472"
        stroke="#7E7E7E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25781"
      />
    </svg>
  );
}
